import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {format} from "date-fns";

import {Button, ListItem, Pagination, Row, Spinner,} from "@deere/ux.uxframe-react";
import {ReactComponent as ChevronLeftIcon} from "@deere/ux.brand-foundations/icons/chevron_left.svg";
import {ReactComponent as ChevronRightIcon} from "@deere/ux.brand-foundations/icons/chevron_right.svg";
import {printContentById} from "../common/PrintUtils";
import {
    dealerSearchData,
    getMachines,
    getMachinesForCustomer,
    getMachinesForDealer,
    hasMoreRecords,
    machineListLoading,
    machinesForCustomers,
    machinesForDealer,
    machinesList,
    pageNumber,
    pageSize,
    recordCount,
    searchedPin,
    totalRecords,
} from "./machineSearchSlice";
import {TextFilter, WtyReportTable,} from "../common/wty-report-table/WtyReportTable";
import ExportMachineList from "../export-to-excel/ExportMachineList";
import {
    expirationReportPageHasMoreRecords,
    expirationReportPageNumber,
    expirationReportPageSize,
    expirationReportRecordCount,
    expirationTotalRecords,
    getExpirationReport,
} from "../expiration-report/expirationReportSlice";
import {languageResponseData} from "../Translation/translationSerachSlice";

const MachineList = ({machineSearchType, entityId, customer}) => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };

    const machines = useSelector(machinesList);
    const machinesOfCustomer = useSelector(machinesForCustomers);
    const machineSearchLoading = useSelector(machineListLoading);
    const machinesOfDealers = useSelector(machinesForDealer);
    const dealerSearchObj = useSelector(dealerSearchData);

    let machineList;
    if (machineSearchType === "machines") {
        machineList = machines;
    } else if (machineSearchType === "customer") {
        machineList = machinesOfCustomer;
    } else if (machineSearchType === "dealer") {
        machineList = machinesOfDealers;
    }

    const machineListHeaders = [
        {
            Header: translate("pin", "Pin"),
            accessor: "pin",
            Filter: TextFilter,
        },
        {
            Header: translate("model", "Model"),
            accessor: "model",
            Filter: TextFilter,
        },
        {
            Header: translate("description", "Description"),
            accessor: "modelDescription",
            Filter: TextFilter,
        },
        {
            Header: translate("model_year", "Model Year"),
            accessor: "modelYear",
            Filter: TextFilter,
        },
        {
            Header: translate("sold_as", "Sold As"),
            accessor: "soldAs",
            Filter: TextFilter,
        },
        {
            Header: translate("last_rep_meas", "Last Rep Meas."),
            accessor: "lastReportedMeasurement",
            Filter: TextFilter,
        },
        {
            Header: translate("delivery_date", "Delivery Date"),
            accessor: "deliveryDate",
            Filter: TextFilter,
        },
        /*{
                Header: 'Open PIP?',
                accessor: 'openPip',
                Filter: TextFilter
            },*/
        {
            Header: translate("responsible_dealer", "Responsible Dealer"),
            accessor: "responsibleDealer",
            Filter: TextFilter,
        },
        {
            Header: translate("customer_name", "Customer Name"),
            accessor: "customerName",
            Filter: TextFilter,
        },
    ];

    let machineListTableData = [];

    /*Mapping machine data to table object*/

    if (machineList && Array.isArray(machineList) && machineList.length > 0) {
        machineListTableData = machineList.map((machineData) => {
            const indCustomerName = [
                machineData.firstName,
                machineData.middleName,
                machineData.lastName,
            ]
                .map((name) => name?.trim())
                .filter(Boolean)
                .join(" ");
            const customerName =
                machineData.businessName1?.trim() ||
                machineData.businessName2?.trim() ||
                indCustomerName ||
                "N/A";
            const deliveryDate = format(
                new Date(machineData.deliveryReceiptDate),
                "yyyy-MM-dd"
            );
            return {
                pin:
                    machineData.pinNumber17 ||
                    machineData.ntvPin ||
                    machineData.pinNumber13,
                model: machineData.modelName ? machineData.modelName : "",
                modelDescription: machineData.modelDescription
                    ? machineData.modelDescription
                    : "",
                modelYear: machineData.modelYear ? machineData.modelYear : "",
                soldAs: machineData.newUsedIndicator === "N" ? "New" : "Used",
                lastReportedMeasurement: machineData.lastReportedMeasurement
                    ? machineData.lastReportedMeasurement
                    : "",
                deliveryDate: deliveryDate ? deliveryDate : "",
                openPip: "NA",
                responsibleDealer: machineData.serviceDealerNum
                    ? machineData.serviceDealerNum
                    : "",
                customerName: customerName ? customerName : "",
            };
        });
    }

    return (
        <div>
            {machineSearchLoading ? (
                <div className="d-flex w-100 justify-content-center align-items-center">
                    <Spinner
                        accessibilityLabel="Loading"
                        className="uxf-spinner-border-lg"
                        animation="border"
                    />
                </div>
            ) : machineList && machineList.length > 0 ? (
                <div>
                    <Row
                        style={{
                            marginBottom: ".5rem",
                            marginTop: "1rem",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            variant="secondary"
                            onClick={() => {
                                if (machineSearchType === "customer") {
                                    const originalState = document.body.innerHTML;
                                    document.body.innerHTML = document.getElementById("customer-info").innerHTML
                                        + document.getElementById("machine-list-data").innerHTML;
                                    window.print();
                                    document.body.innerHTML = originalState;
                                    window.location.reload();
                                }
                                 else printContentById("machine-list-data", "Machine Search");
                            }
                            }
                        >
                            Print to Pdf
                        </Button>{" "}
                        &nbsp; &nbsp;
                        <ExportMachineList
                            machines={machineList}
                            searchType={machineSearchType}
                            customer={customer}
                        />
                    </Row>
                    <WtyReportMachineListPagination
                        searchType={machineSearchType}
                        entityId={entityId}
                        dealerSearchObj={dealerSearchObj}
                    />
                    <div
                        id="machine-list-data"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <WtyReportTable
                            columns={machineListHeaders}
                            data={machineListTableData}
                            dataType={"MachineData"}
                            machineSearchType={machineSearchType}
                        />
                    </div>
                    <WtyReportMachineListPagination
                        searchType={machineSearchType}
                        entityId={entityId}
                        dealerSearchObj={dealerSearchObj}
                    />
                    <Row
                        style={{
                            marginBottom: ".5rem",
                            marginTop: "1rem",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            variant="secondary"
                            onClick={() =>
                                printContentById("machine-list-data", "Machine Search")
                            }
                        >
                            Print to Pdf
                        </Button>{" "}
                        &nbsp; &nbsp;
                        <ExportMachineList
                            machines={machineList}
                            searchType={machineSearchType}
                        />
                    </Row>
                </div>
            ) : (
                translate("message14", "No Machines found for customer")
            )}
        </div>
    );
};

export const WtyReportMachineListPagination = ({
                                                   searchType,
                                                   entityId,
                                                   dealerSearchObj,
                                                   expirationSearchPayload,
                                               }) => {
    const dispatch = useDispatch();
    const expirationPageNumber = useSelector(expirationReportPageNumber);
    const expirationPageSize = useSelector(expirationReportPageSize);
    const totalExpResults = useSelector(expirationReportRecordCount);
    const currentPageSize = useSelector(pageSize);
    const currentPage = useSelector(pageNumber);
    const hasMoreExpiration = useSelector(expirationReportPageHasMoreRecords);
    const hasMore = useSelector(hasMoreRecords);
    const searchedSerial = useSelector(searchedPin);
    let currPageDataCount = useSelector(recordCount);
    const expirationTotalCount = useSelector(expirationTotalRecords);
    const totalCount = useSelector(totalRecords);
    const totalRecord =
        searchType === "expiration-report" ? expirationTotalCount : totalCount;

    const startNumber = (expirationPageNumber - 1) * expirationPageSize + 1;
    const endNumber =
        totalExpResults < 200
            ? expirationPageNumber * expirationPageSize - 200 + totalExpResults
            : expirationPageNumber * expirationPageSize;

    const start =
        searchType === "expiration-report"
            ? startNumber
            : (currentPage - 1) * currentPageSize + 1;

    const expirationReportDataCount = useSelector(expirationReportRecordCount);

    currPageDataCount =
        searchType === "expiration-report"
            ? expirationReportDataCount
            : currPageDataCount;

    const currentPageSizeExpReportData = useSelector(pageSize);
    const currentPageExpReportData = useSelector(pageNumber);
    const hasMoreExpReportData = useSelector(hasMoreRecords);
    const searchedSerialExpReportData = useSelector(searchedPin);
    const currPageDataCountExpReportData = useSelector(recordCount);
    const startExpReportData =
        (currentPageExpReportData - 1) * currentPageSizeExpReportData + 1;
    let endExpReportData =
        currPageDataCountExpReportData < 200
            ? currentPageExpReportData * currentPageSizeExpReportData -
            200 +
            currPageDataCountExpReportData
            : currentPageExpReportData * currentPageSize;

    /*Reduce the count of end in case of less than 200 results the last page*/
    let end =
        searchType === "expiration-report"
            ? endNumber
            : currPageDataCount < 200
                ? currentPage * currentPageSize - 200 + currPageDataCount
                : currentPage * currentPageSize;

    const onFetchNextPage = () => {
        let searchObject = {};
        if (searchType === "machines") {
            searchObject = {
                searchedPin: searchedSerial,
                searchType: "partialPin",
                pageSize: currentPageSize,
                pageNumber: currentPage + 1,
            };
            dispatch(getMachines(searchObject));
        }
        if (searchType === "customer") {
            searchObject = {
                entityId: entityId,
                pageSize: "200",
                pageNumber: currentPage + 1,
            };
            dispatch(getMachinesForCustomer(searchObject));
        } else if (searchType === "dealer") {
            /*dealerSearchObject is fetched from state.*/
            dealerSearchObj = {
                ...dealerSearchObj,
                pageNumber: currentPage + 1,
            };
            dispatch(getMachinesForDealer(dealerSearchObj));
        }
        if (searchType === "expiration-report") {
            let expirationLocalPayload = {
                ...expirationSearchPayload,
                pageNumber: expirationPageNumber + 1,
            };
            dispatch(getExpirationReport(expirationLocalPayload));
        }
    };
    const onFetchPreviousPage = () => {
        let searchObject = {};
        if (searchType === "machines") {
            searchObject = {
                searchedPin: searchedSerial,
                searchType: "partialPin",
                pageSize: currentPageSize,
                pageNumber: currentPage - 1,
            };
            dispatch(getMachines(searchObject));
        } else if (searchType === "customer") {
            searchObject = {
                entityId: entityId,
                pageSize: "200",
                pageNumber: currentPage - 1,
            };
            dispatch(getMachinesForCustomer(searchObject));
        } else if (searchType === "dealer") {
            dealerSearchObj = {
                ...dealerSearchObj,
                pageNumber: currentPage - 1,
            };
            dispatch(getMachinesForDealer(dealerSearchObj));
        }
        if (searchType === "expiration-report") {
            let expirationLocalPayload = {
                ...expirationSearchPayload,
                pageNumber: expirationPageNumber - 1,
            };
            dispatch(getExpirationReport(expirationLocalPayload));
        }
    };

    return (
        <>
            {
                searchType === "expiration-report" || searchType === "dealer" ? (
                    <Pagination
                        pageResults={true}
                        text={`${start} - ${end} Results`}
                        ariaLabel="Page navigation example"
                        className="uxf-pagination-mobile-first justify-content-center"
                    >
                        <Pagination.Item aria-label="previous">
                            <ChevronLeftIcon/>
                        </Pagination.Item>
                        <ListItem className="uxf-pagination-mobile-page">
                            {`${start}`} - {`${end}`} Results
                        </ListItem>
                        <Pagination.Item
                            disabled={
                                searchType === "expiration-report"
                                    ? expirationPageNumber === 1
                                    : currentPage === 1
                            }
                            onClick={onFetchPreviousPage}
                        >
                            Previous
                        </Pagination.Item>
                        <Pagination.Item active>
                            {searchType === "expiration-report"
                                ? expirationPageNumber
                                : currentPage}
                        </Pagination.Item>
                        <Pagination.Item
                            disabled={
                                searchType === "expiration-report" ? !hasMoreExpiration : !hasMore
                            }
                            onClick={onFetchNextPage}
                        >
                            Next
                        </Pagination.Item>
                        <Pagination.Item aria-label="next">
                            <ChevronRightIcon/>
                        </Pagination.Item>
                    </Pagination>
                ) : (
                    <Pagination
                        pageResults={true}
                        text={`${start} - ${end} of ${totalRecord} Results`}
                        ariaLabel="Page navigation example"
                        className="uxf-pagination-mobile-first justify-content-center">
                        <Pagination.Item aria-label="previous">
                            <ChevronLeftIcon/>
                        </Pagination.Item>
                        <ListItem className="uxf-pagination-mobile-page">
                            {`${start}`} - {`${end}`} of {`${totalRecord}`} Results
                        </ListItem>
                        <Pagination.Item
                            disabled={
                                searchType === "expiration-report"
                                    ? expirationPageNumber === 1
                                    : currentPage === 1
                            }
                            onClick={onFetchPreviousPage}
                        >
                            Previous
                        </Pagination.Item>
                        <Pagination.Item active>
                            {searchType === "expiration-report"
                                ? expirationPageNumber
                                : currentPage}
                        </Pagination.Item>
                        <Pagination.Item
                            disabled={
                                searchType === "expiration-report" ? !hasMoreExpiration : !hasMore
                            }
                            onClick={onFetchNextPage}
                        >
                            Next
                        </Pagination.Item>
                        <Pagination.Item aria-label="next">
                            <ChevronRightIcon/>
                        </Pagination.Item>
                    </Pagination>
                )
            }
        </>
    );
};

export default MachineList;
